// extracted by mini-css-extract-plugin
export default {"question_container":"Question_question_container__Mljy-","question":"Question_question__IdAhv","active":"Question_active__SdmWF"};